<template>
    <div class="renzheng-box">
        <img class="icon-rz" src="@/assets/images/icon-rz.png" alt="" />
        <div class="rz1">实名认证</div>
        <div class="rz-tip">购买数字藏品需完成实名认证</div>
        <div class="input-wrapper isShow">
            <input class="input-name" placeholder="真实姓名" v-model="name"/>
        </div>
        <img
            class="line-1 input-line isShow"
            src="@/assets/images/input-line.png"
            alt=""
        />
        <div class="input-wrapper input-sf isShow">
            <input class="input-idcard" placeholder="身份证号码" type="text" v-model="idcard"/>
        </div>
        <img
            class="input-line isShow"
            src="@/assets/images/input-line.png"
            alt=""
        />
        <!-- <div class="shenfen isShow">信息仅用于核对真实身份</div> -->
        <div class="btn-renzheng active" @click="submit">认证</div>
        <div class="shenfen-text-title isShow">信息仅用于核对真实身份</div>
        <div class="shenfen-text-content isShow">
            1·当前登录手机号码需为实名认证
        </div>
        <div class="shenfen-text-content isShow">
            2·身份证信息需与登录手机号码实名认证信息一致
        </div>
        <div class="shenfen-text-content isShow">3·信息认证成功后不可修改</div>
        <div class="shenfen-text-content isShow">
            4·登录手机号码不建议使用集团号、家庭亲情副卡号
        </div>
        <div class="shenfen-text-content isShow">
            5·身份信息为未成年认证不通过
        </div>
        <!-- <img class="tips-err" src="@/assets/images/tips-err.png" alt="" /> -->
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>